import { cva } from 'class-variance-authority';
import { ElementIntent } from '../../enums';
export const alertStyling = cva('flex gap-stack items-start p-stack-roomy rounded-card-sm text-body-sm ring-1 ring-offset-2', {
    variants: {
        intent: {
            [ElementIntent.Info]: 'bg-surface-muted ring-border',
            [ElementIntent.Success]: 'bg-success-subtle ring-success-ring',
            [ElementIntent.Warning]: 'bg-warning-subtle ring-warning-ring',
            [ElementIntent.Danger]: 'bg-danger-subtle ring-danger-ring',
        },
    },
    defaultVariants: {
        intent: ElementIntent.Info,
    },
});
export const alertIconStyling = cva('flex rounded-pill size-6 mt-stack-dense', {
    variants: {
        intent: {
            [ElementIntent.Info]: 'text-fg-disabled',
            [ElementIntent.Success]: 'text-success',
            [ElementIntent.Warning]: 'text-fg-inverse bg-warning',
            [ElementIntent.Danger]: 'text-danger',
        },
    },
    defaultVariants: {
        intent: ElementIntent.Info,
    },
});
